import Button from '@hellodarwin/core/lib/components/common/button';
import useMediaQuery from '@hellodarwin/core/lib/features/helpers/use-media-query';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { useAppSelector } from '../../../../../../app/app-hooks';
import { onboardingIsLoading } from '../../../../api/onboarding-slice';
import { useOnboardingFlow } from '../../../../hooks/useOnboardingFlow';
import { StyledFooter } from './styles';

interface OnboardingStepFooterProps {
  hideBack?: boolean;
  hideNext?: boolean;
}

/**
 * Footer component with back/next navigation and skip option
 */
const OnboardingStepFooter: React.FC<OnboardingStepFooterProps> = ({
  hideBack,
  hideNext,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const {
    isStepValid,
    handleSubmitStep,
    currentStepContent,
    goToPreviousStep,
  } = useOnboardingFlow();

  const isSubmittingOnboarding = useAppSelector(onboardingIsLoading);

  const isSubmitStep = useMemo(
    () => currentStepContent?.isSubmitStep,
    [currentStepContent],
  );
  const handleBack = () => {
    goToPreviousStep();
  };

  const handleNext = () => {
    handleSubmitStep();
  };

  const isMobile = useMediaQuery({ maxWidth: theme.breakpoints.mobile });

  return (
    <StyledFooter>
      {!hideBack && (
        <Button
          onClick={handleBack}
          defaultStyle={theme.colors.white_1}
          withArrowLeft
          shape="rounded-corner"
          size={isMobile ? 'small' : 'medium'}
        >
          {t('button|back')}
        </Button>
      )}

      {!hideNext && (
        <Button
          onClick={handleNext}
          disabled={!isStepValid || isSubmittingOnboarding}
          defaultStyle={theme.colors.grey_1}
          withArrowRight={!isSubmitStep}
          shape="rounded-corner"
          size={isMobile ? 'small' : 'medium'}
        >
          {isSubmitStep ? t('button|submit') : t('button|next')}
        </Button>
      )}
    </StyledFooter>
  );
};

export default OnboardingStepFooter;
